module.exports = __webpack_public_path__ + "static/cash-2869a6f109ff693e4a5529fd0d945275.png";